var players = [];

function onPlayerReady(event) {}

function onYouTubeIframeAPIReady() {
  var widgets = document.querySelectorAll('.elementor-widget-video');

  widgets.forEach(function (widget, index) {
    var settings = JSON.parse(widget.getAttribute('data-settings'));

    if (!settings || !settings.youtube_url) {
      console.error('No YouTube URL found in widget settings');
      return;
    }

    var videoUrl = new URL(settings.youtube_url);
    var videoId = videoUrl.searchParams.get('v');

    if (!videoId) {
      console.error('No video ID found in YouTube URL');
      return;
    }

    var iframe = widget.querySelector('.elementor-video');

    if (!iframe) {
      console.error('No iframe found in widget');
      return;
    }

    // Generate a unique ID for the iframe
    var uniqueId = 'player' + index + '-' + Date.now();
    iframe.id = uniqueId;

    var player = new YT.Player(uniqueId, {
      videoId: videoId,
      playerVars: {
        autoplay: 0, // Disable autoplay
        mute: 1, // Start with muted video
      },
      events: {
        onReady: onPlayerReady,
      },
    });

    players.push(player);

    widget.addEventListener('mouseover', function () {
      if (player && typeof player.playVideo === 'function') {
        player.playVideo();
      }
    });

    widget.addEventListener('mouseout', function () {
      if (player && typeof player.pauseVideo === 'function') {
        player.pauseVideo();
        player.seekTo(0); // Rewind the video to the beginning
      }
    });

    widget.addEventListener('click', function () {
      if (player && typeof player.unMute === 'function') {
        player.unMute();
      }
    });
  });
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

// Load the IFrame Player API code asynchronously.
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
tag.async = true; // Add this line to load the script asynchronously
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
